import { Layout } from 'antd';
import { BaseLayoutComponent } from '@components';
import LeadStatsCards from './LeadStatsCards';
import LeadStatusTable from './LeadStatusTable';
import HeadingTypography from '../../shared/Typography/Heading';
import DateRange from '../../shared/dataRange';
import useGetLeadsBasicData from 'src/app/hooks/useGetLeadsBasicData';
import { useLeadContext } from '@contexts';

const { Content } = Layout;

export const LeadPageComponent = () => {
        const { setDate } = useLeadContext();
    
    useGetLeadsBasicData();

    return (
        <>
            <BaseLayoutComponent
                children={
                    <Content className="m-5 bg">
                        <div className="flex justify-between">
                            <HeadingTypography fontSize={24}>Leads</HeadingTypography>
                            <DateRange setDate={setDate} />
                        </div>
                        <LeadStatsCards />
                        <LeadStatusTable />

                    </Content>
                }
            />
        </>
    );
};
